import { create } from "zustand";
import { persist } from "zustand/middleware";
import {
  Category,
  Degree,
  Industry,
  Level,
} from "@/modules/types/metadata/metadata";
import { Subscription } from "@/modules/types/subscription/subscription";

interface MetadataState {
  categories: Category[];
  levels: Level[];
  degrees: Degree[];
  subscriptionPacks: Subscription[];
  industries: Industry[];
  expiredAt: number;
}

interface MetadataActions {
  setCategories: (categories: Category[]) => void;
  setLevels: (levels: Level[]) => void;
  setDegrees: (degrees: Degree[]) => void;
  setSubscriptionPacks: (packs: Subscription[]) => void;
  setExpiredAt: (expiredAt: number) => void;
  setIndustries: (industries: Industry[]) => void;
}

export type MetadataStore = MetadataState & MetadataActions;

const initialState: MetadataState = {
  categories: [],
  levels: [],
  degrees: [],
  subscriptionPacks: [],
  industries: [],
  expiredAt: 0,
};

export const useMetadataStore = create<MetadataStore>()(
  persist(
    (set) => ({
      ...initialState,
      setCategories: (categories) => set({ categories }),
      setLevels: (levels) => set({ levels }),
      setDegrees: (degrees) => set({ degrees }),
      setSubscriptionPacks: (subscriptionPacks) => set({ subscriptionPacks }),
      setExpiredAt: (expiredAt) => set({ expiredAt }),
      setIndustries: (industries) => set({ industries }),
    }),
    {
      name: "metadata",
    }
  )
);

export const useIsExpired = () => {
  const expiredAt = useMetadataStore((state) => state.expiredAt);
  const now = new Date().getTime();
  return now > new Date(expiredAt).getTime();
};
